import * as React from 'react';
import {emotionStyled} from '@packages/utilities/styled';
import {MenuItem, Text} from '@packages/systems/spring';

const MenuItemView = emotionStyled(MenuItem)(
  {},
  {
    variants: {
      isSelected: {
        true: {
          backgroundColor: '$uiBackgroundActive',
        },
      },
    },
  }
);

export const DatePickerMenuItem = ({
  children,
  onClick,
  value,
}: {
  children: React.ReactNode;
  onClick: (event: Event) => void;
  value: string;
}) => {
  return (
    <MenuItemView
      // @ts-expect-error TS2322
      onClick={onClick}
      shouldCloseOnClickItem={false}
      value={value}
    >
      <Text className="flex" colorVariant="primary">
        {children}
      </Text>
    </MenuItemView>
  );
};
